<template>
  <div class="subject" id="subject" :style="{ 'max-width': mainWidth + 'px' }">
    <div class="editortitle">详细信息</div>
    <p v-html="content"></p>
  </div>
</template>
<script>
export default {
  name: 'subject',
  props: {
    content: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 1200,
    },
  },
  data() {
    return {
      mainWidth: this.width,
      isPhone: false, // 是否是手机浏览器
    };
  },
  watch: {
    width(value) {
      this.mainWidth = value;
    },
  },
  created() {
    try {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.isPhone = true;
        this.mainWidth = document.body.clientWidth - 40;
        this.updateStyle();
      }
    } catch (e) {}
  },
  mounted() {
    this.updateStyle();
  },
  methods: {
    updateStyle() {
      // document.getElementById('subject') 包裹层
      let obj = document.getElementById('subject');
      let imgs = obj.getElementsByTagName('img');

      for (let i = 0; i < imgs.length; i++) {
        imgs[i].style.maxWidth = this.mainWidth + 'px';
      }
    },
  },
};
</script>
<style scoped>
.editortitle {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #222222;
  line-height: 28px;
  margin-bottom: 20px;
}
.subject {
  /* text-align: center; */
  /* margin-bottom: 100px; */
  font-size: 16px;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(34, 34, 34, 1);
  padding-top: 40px;
  background: #fff;
}

.subject >>> img {
  max-width: 1200px;
  margin: 20px 0;
  text-align: center;
}
.subject >>> p {
}
</style>
